import { render, staticRenderFns } from "./SendTrainingVideoComplete.vue?vue&type=template&id=12958578&scoped=true&"
import script from "./SendTrainingVideoComplete.vue?vue&type=script&lang=js&"
export * from "./SendTrainingVideoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12958578",
  null
  
)

export default component.exports